import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserEventTypes } from '../../../bundles/events';
import { getEventTimeLineAdminSchema } from '../../panels/EventTimelinePanel/jsonSchema';
import JsonEditor from '../../JsonEditor';

const EVENT_TYPES_REQUIRED_ERROR_PATH = '.filters.eventTypes.types';
const EVENT_TYPES_REQUIRED_ERROR_MESSAGE = 'Select at least one event type to save panel settings.';
const DTMP_EXCLUDE_TYPES_ERROR_PATH = '.filters.eventTypes.dtmpExcludeTypes';
const DTMP_EXCLUDE_TYPES_ERROR_MESSAGE = 'At least 1 event type must be included.';

const transformValidationErrors = (validationErrors = []) =>
  validationErrors.map((validationError) => {
    const hasNoEventTypeSelectionError =
      validationError.name === 'minItems' &&
      validationError.property === EVENT_TYPES_REQUIRED_ERROR_PATH;

    const hasAllDtmpTypesExcludedError =
      validationError.name === 'maxItems' &&
      validationError.property === DTMP_EXCLUDE_TYPES_ERROR_PATH;

    if (hasNoEventTypeSelectionError) {
      return { ...validationError, message: EVENT_TYPES_REQUIRED_ERROR_MESSAGE };
    }

    if (hasAllDtmpTypesExcludedError) {
      return { ...validationError, message: DTMP_EXCLUDE_TYPES_ERROR_MESSAGE };
    }

    return validationError;
  });

const EventTimelineSettings = ({ settings, onSave, onFullSettings, onClose }) => {
  const eventTypes = useSelector(getUserEventTypes);
  const [eventTimelineSettings, setEventTimelineSettings] = useState(() => settings);

  useEffect(() => {
    setEventTimelineSettings(settings);
  }, [settings]);

  const schema = useMemo(
    () => getEventTimeLineAdminSchema(eventTypes, eventTimelineSettings),
    [eventTypes, eventTimelineSettings]
  );

  return (
    <div className="column-content">
      <JsonEditor
        title=""
        schema={schema}
        formData={eventTimelineSettings}
        customTransformErrors={transformValidationErrors}
        onFormChange={({ formData }) => {
          setEventTimelineSettings(formData);
        }}
        onFormSubmit={onSave}
        onSecondaryAction={onFullSettings}
        cancelCallback={onClose}
        saveButtonText={'Save'}
        initialEditMode
        showEditButton={false}
      />
    </div>
  );
};
export default EventTimelineSettings;
